import { Component, OnInit } from '@angular/core';
import { CustomerContact } from 'src/app/classes/customer-contact';
import locales from 'src/app/constants/locales';
import { environment } from 'src/environments/environment';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomerService } from 'src/app/services/customer.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { LanguageSelectorComponent } from '../../common/language-selector/language-selector.component';
import { ContactService } from 'src/app/services/contact.service';
import { Title } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-require-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.scss'],
})
export class PasswordChangeComponent  implements OnInit {
  locales = locales
  locale = $localize.locale
  environment = environment
  fa = fa
  showPassword = false
  showConfirmPassword = false

  contact = new CustomerContact()

  form = new FormGroup({
    password: new FormControl('', [Validators.required, Validators.minLength(12), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/)]),
    confirm_password: new FormControl('', [
      Validators.required,
      (control) => {
        if (!control.value) {
          return null;
        }
        const password = control.root.get('password');
        return password && control.value === password.value ? null : { passwordMismatch: true };
      }
    ]),
  })

  constructor(
    private customerService: CustomerService,
    private contactService: ContactService,
    public activeModal: NgbActiveModal,
    private authService: AuthService,
    private modalService: NgbModal,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.form.get('password')?.valueChanges.subscribe(() => {
      this.form.get('confirm_password')?.updateValueAndValidity({ onlySelf: true });
    })
    
    this.titleService.setTitle($localize`Set new password`)

    this.customerService.current().subscribe(contact => {
      this.contact = contact
    })
  }

  languageSelector() {
    const modal = this.modalService.open(LanguageSelectorComponent, { centered: true, size: 'md' })
  }

  changePassword() {
    this.contactService.setPassword(this.form.controls.password.value).subscribe(result => {
      this.activeModal.close()
      
      // Just call something that triggers 403
      this.customerService.ping().subscribe({
        next: () => this.authService.loginNavigate()
      })
    })
  }
}
